export default __webpack_public_path__ + "static/media/Subjugator Blade.8200afdc.jpg";